import { StreamId } from "@common/domain";
import { PlainExtendedMediaStream } from "../../extended-media-stream";
import { SafeAudioContext } from "../../utils";
import { LocalConferenceStream } from "./LocalConferenceStream";

export class LocalAudioConferenceStream extends LocalConferenceStream {
  private readonly _audio: HTMLAudioElement;

  constructor(
    streamId: StreamId,
    private readonly file: File,
    private readonly _audioElementFactory: () => HTMLAudioElement,
    logger: (...args: unknown[]) => void
  ) {
    super(streamId, logger);

    this._audio = this._audioElementFactory();
    this._audio.src = URL.createObjectURL(this.file);
    this._audio.loop = true;

    const stream = new PlainExtendedMediaStream(new MediaStream());

    const audioContext = new SafeAudioContext();
    const mp3AudioSource = audioContext.createMediaElementSource(this._audio);
    const mp3AudioDestination = audioContext.createMediaStreamDestination();
    mp3AudioSource.connect(mp3AudioDestination);

    mp3AudioDestination.stream
      .getAudioTracks()
      .forEach((_) => stream.addTrack(_));

    this._stream$.next(stream);
  }

  override async audioDisable() {
    this._audio.muted = true;

    await super.audioDisable();
  }

  override async audioEnable() {
    this._audio.muted = false;

    await super.audioEnable();
  }

  async play() {
    return this._audio.play();
  }

  pause() {
    this._audio.pause();
  }

  restart() {
    this._audio.currentTime = 0;
  }
}
